/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Entrepreneurial_Thinking23Inputs */

const en_job_form_enum_entrepreneurial_thinking23 = /** @type {(inputs: Job_Form_Enum_Entrepreneurial_Thinking23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrepreneurial Thinking`)
};

const de_job_form_enum_entrepreneurial_thinking23 = /** @type {(inputs: Job_Form_Enum_Entrepreneurial_Thinking23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmerisches Denken`)
};

/**
* | output |
* | --- |
* | "Entrepreneurial Thinking" |
*
* @param {Job_Form_Enum_Entrepreneurial_Thinking23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_entrepreneurial_thinking23 = /** @type {((inputs?: Job_Form_Enum_Entrepreneurial_Thinking23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Entrepreneurial_Thinking23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_entrepreneurial_thinking23(inputs)
	return en_job_form_enum_entrepreneurial_thinking23(inputs)
});
export { job_form_enum_entrepreneurial_thinking23 as "job_form_enum_ENTREPRENEURIAL_THINKING" }